<template>
  <div class="employeesCreate">
    <CloseModalBtn :closeModal="closeModal" />
    <div class="step" v-if="step === 1">
      <h5 class="f24 fw500">
        {{
          localStorage.translations.pages.personnel_department.dialog_addemployee[
            'vyberite-polzovatelya'
          ]
        }}
      </h5>
      <div class="step_list">
        <label class="step_list_item" v-for="item in userReady" :key="item.id">
          <div class="step_list_item_text">
            <p class="name f14">
              {{ item.first_name + ' ' + item.last_name }}
            </p>
            <p class="email f12">{{ item.email }}</p>
          </div>
          <div class="step_list_item_button">
            <input type="radio" :value="item" v-model="selectedUser" />
            <span class="checkmark"><Check /></span>
          </div>
        </label>
        <div class="noData f16" v-if="!userReady.length">
          {{ localStorage.translations.pages.common.text['net-dannyh'] }}
        </div>
      </div>
      <button class="next" @click="onCheckAccessStep" :class="{ disabled: !selectedUser }">
        +
        {{
          localStorage.translations.pages.personnel_department.dialog_addemployee_buttons['vybrat']
        }}
      </button>
    </div>
    <div class="step two" v-else>
      <h5>
        {{
          localStorage.translations.pages.personnel_department.dialog_addemployee[
            'naznachit-rol-sotrudniku'
          ]
        }}
      </h5>
      <div class="box">
        <div class="box_text">
          <p class="box_text_name f14">
            {{ selectedUser.first_name + ' ' + selectedUser.last_name }}
          </p>
          <p class="box_text_email f12">{{ selectedUser.email }}</p>
        </div>
        <div class="box_role">
          <v-label>
            {{
              localStorage.translations.pages.personnel_department.dialog_addemployee_labels['rol']
            }}
          </v-label>
          <v-autocomplete
            outlined
            dense
            :placeholder="localStorage.translations.pages.common.text.not_assigned"
            class="selectCustom"
            append-icon="fas fa-angle-down"
            :items="rolesAllData"
            color="white"
            item-value="role_name"
            item-text="role_name"
            v-model="roleSelect"
          ></v-autocomplete>
        </div>
      </div>
      <button class="next f15" :class="{ disabled: !roleSelect }" @click="createEmployee">
        +
        {{
          localStorage.translations.pages.personnel_department.dialog_addemployee_buttons[
            'naznachit'
          ]
        }}
      </button>
    </div>
  </div>
</template>

<script>
import Check from 'components/icons/radio/Check'
import { mapActions, mapGetters } from 'vuex'
import CloseModalBtn from 'components/CloseModalBtn'

export default {
  name: 'EmployeesCreateModalList',
  components: { CloseModalBtn, Check },
  props: ['closeModal'],
  data() {
    return {
      selectedUser: null,
      roleSelect: null,
      search: null,
      step: 1,
    }
  },
  created() {
    this.onCommonUserGridAll()
    this.roleList()
  },
  computed: {
    ...mapGetters('commonUser', ['commonUserGridAll']),
    rolesAllData() {
      return this.$store.getters['commonRole/rolesAllData']
    },
    userReady() {
      return this.commonUserGridAll
        ? this.commonUserGridAll.filter((i) => i.employee === null && i.status === 'authorized')
        : null
    },
  },
  watch: {
    selectedUser() {
      if (this.selectedUser.roles.length) {
        this.roleSelect = this.selectedUser.roles[0].role_name
      }
    },
  },
  methods: {
    ...mapActions('commonUser', ['onCommonUserGridAll']),
    ...mapActions('employee', ['onEmployeeListGroupsAndWorkTypes']),
    roleList() {
      this.$store.dispatch('commonRole/listOfRolesAll')
    },
    onCheckAccessStep() {
      if (
        this.$userCheckAccess({
          abilities: 'assign_user_roles',
        })
      ) {
        this.step = 2
      } else {
        this.createEmployee()
      }
    },
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      // if (this.filterParams.length) {
      //     data.filters = this.filterParams
      // }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onEmployeeListGroupsAndWorkTypes(data)
    },
    async createEmployee() {
      await this.$store
        .dispatch('employee/employeeCreate', {
          user_id: this.selectedUser.id,
        })
        .then((response) => {
          if (response) {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-dobavlen'],
                IsError: false,
              },
              { root: true },
            )
            this.downloadPageData()
          }
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          }
        })
      if (
        this.$userCheckAccess({
          abilities: 'assign_user_roles',
        })
      ) {
        await this.$store
          .dispatch('commonRole/assingRoleToUser', {
            user_id: this.selectedUser.id,
            roles: [this.roleSelect],
          })
          .then((response) => {
            if (response) {
              this.closeModal()
            }
          })
      } else {
        this.closeModal()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.employeesCreate {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  position: relative;
  .noData {
    padding: 15px 0;
  }
  .step {
    h5 {
      padding: 30px 30px 10px;
      line-height: 28px;
      text-align: center;
      color: #2c2c2c;
    }
    :deep().search {
      .v-input__slot {
        padding: 16px 30px;
        .v-icon {
          margin: 0 !important;
          font-size: 1.125rem;
        }
      }
    }
    &_list {
      max-height: 568px;
      overflow-y: scroll;
      display: grid;
      border-top: 1px solid #696969;
      border-bottom: 1px solid #696969;
      scrollbar-color: #b4b4b4;
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        width: 8px;
        background: lightgray;
      }

      &::-webkit-scrollbar-thumb {
        background: #b4b4b4;
      }
      &_item {
        height: 70px;
        display: grid;
        padding: 18px 30px;
        grid-template-columns: auto max-content;
        align-items: center;
        cursor: pointer;
        transition: 0.2s;
        border-bottom: 1px solid #dbdbdb;
        // &:not(:last-of-type) {
        //     border-bottom: 1px solid #dbdbdb;
        // }
        &_text {
          display: grid;
          grid-template-rows: max-content;
          grid-row-gap: 4px;
          justify-content: start;
          p {
            margin: 0;
            text-align: start;
            &.name {
              font-weight: normal;
              line-height: 16px;
              color: #52525f;
            }
            &.email {
              font-weight: normal;
              line-height: 14px;
              color: #277faf;
            }
          }
        }
        &_button {
          position: relative;

          input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            &:checked {
              ~ {
                .checkmark {
                  background-color: #277faf;
                  border: 2px solid #277faf;
                  svg {
                    display: block;
                  }
                }
              }
            }
          }
          .checkmark {
            width: 24px;
            height: 24px;
            border: 2px solid #2c2c2c;
            border-radius: 50%;
            display: grid;
            align-items: center;
            justify-content: center;
            svg {
              display: none;
            }
          }
        }
        &:hover {
          background: #277faf;
          .step_list_item_text {
            p {
              &.name {
                color: #ffffff;
              }
              &.email {
                color: #ffffff;
              }
            }
          }
          .step_list_item_button {
            .checkmark {
              border: 2px solid #ffffff;
            }
          }
          input {
            &:checked {
              ~ {
                :deep().checkmark {
                  background-color: #ffffff;
                  border: 2px solid #ffffff;
                  svg {
                    display: block;
                    path {
                      stroke: #277faf;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .next {
      width: 100%;
      height: 55px;
      box-shadow: 0px 8px 16px rgba(67, 142, 184, 0.2);
      font-weight: 500;
      line-height: 16px;
      letter-spacing: 0.04em;
      color: #277faf;
      text-transform: uppercase;
      &:hover {
        background-color: #277faf;
        color: #ffffff;
      }
      &.disabled {
        user-select: none;
        pointer-events: none;
        color: #b4b4b4;
      }
    }
    &.two {
      h5 {
        padding: 30px;
      }
      .box {
        padding: 30px;
        border-top: 1px solid #696969;
        border-bottom: 1px solid #696969;
        display: grid;
        grid-row-gap: 30px;
        justify-content: center;
        justify-items: center;
        &_text {
          text-align: center;
          display: grid;
          grid-row-gap: 4px;
          p {
            margin: 0;
          }
          &_name {
            font-weight: normal;
            line-height: 16px;
            color: #52525f;
          }
          &_email {
            font-weight: normal;
            line-height: 14px;
            color: #277faf;
          }
        }
        &_role {
          width: 200px;
        }
      }
    }
  }
}
</style>
